import api from '../../config/api';

const STATUS_PATHS = ['/permissions/email-queue/status', '/email-queue/status'];
const LIST_PATHS = ['/permissions/email-queue', '/email-queue'];
const TEST_PATHS = ['/permissions/email-queue/test', '/email-queue/test'];

async function requestWithFallback(requestFn, paths) {
  let lastError;
  for (const path of paths) {
    try {
      return await requestFn(path);
    } catch (err) {
      if (err.response?.status === 404) {
        lastError = err;
        continue;
      }
      throw err;
    }
  }
  throw lastError || new Error('Email queue API is not available');
}

export function fetchEmailQueueStatus() {
  return requestWithFallback((path) => api.get(path), STATUS_PATHS).then((r) => r.data);
}

export function fetchEmailQueueEntries(limit = 50) {
  return requestWithFallback(
    (path) => api.get(path, { params: { limit } }),
    LIST_PATHS
  ).then((r) => r.data);
}

export function postEmailQueueTest(to) {
  return requestWithFallback((path) => api.post(path, { to }), TEST_PATHS);
}

export function smtpConfiguredFromPublicConfig(config) {
  const smtp = config?.smtp;
  if (!smtp?.host || !smtp?.from_email) return false;
  return Boolean(smtp.password_set || smtp.password);
}

export function mergeEmailQueueView(status, emailConfig) {
  const fromConfig = smtpConfiguredFromPublicConfig(emailConfig);
  return {
    ...(status || {}),
    enabled: emailConfig?.enabled ?? status?.enabled ?? false,
    smtp_configured: status?.smtp_configured ?? fromConfig,
    smtp_password_set: status?.smtp_password_set ?? emailConfig?.smtp?.password_set ?? false,
    app_name: emailConfig?.app_name ?? status?.app_name ?? 'GoBunnyy',
    counts: status?.counts || {},
    last_entry: status?.last_entry ?? null,
    last_successful: status?.last_successful ?? null,
  };
}
